import Lib from '../../../commons/lib';

export default class Service {
  static cikkUrl = window.location.origin + '/api/cikk/';
  static keszletUrl = window.location.origin + '/api/keszletnyilv/';
  static raktarUrl = window.location.origin + '/api/raktar/';
  static szervezetUrl = window.location.origin + '/api/szervezet/';

// CIKK START


static queryCikk(text, receptura, raktar, csoportIds, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'GET',
    url: Service.cikkUrl + 'cikk/query',
    args: { requestType: 'cikk-query' },
    params: { param: text, receptura, raktar, csoportIds }
  }], fnDone);
}

static queryCikkcsoport(text, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'GET',
    url: Service.cikkUrl + 'cikkcsoport/query',
    args: { requestType: 'cikkcsoport-query' },
    params: { param: text }
  }], fnDone);
}

// CIKK END

// KÉSZLET START


static getRaktarList(cikkek, raktarak, keszletszintSzuro, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'GET',
    url: Service.keszletUrl + 'keszletinfo/list',
    args: { requestType: 'keszletinfo-list' },
    params: { cikkek: cikkek, raktarak: raktarak, keszletinfoSzures: true, keszletszintSzuro }
  }], fnDone);
}

static getFoglalasok(cikkid, raktarid, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'GET',
    url: Service.keszletUrl + 'keszletinfo/foglalasok',
    args: { requestType: 'keszletinfo-foglalasok' },
    params: { cikk: cikkid, raktar: raktarid }
  }], fnDone);
}

static existsSzervezet(fnDone) {
  Lib.MicroServices.requestService([{
    method: 'GET',
    url: Service.keszletUrl + 'leltar/exists/szervezet',
    args: { requestType: 'szervezet-exists' }
  }], fnDone);
}

// KÉSZLET END

// RAKTÁR START


static queryRaktar(text, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'GET',
    url: Service.raktarUrl + 'raktar/searchbytext',
    args: { requestType: 'raktar-searchbytext' },
    params: { text: text }
  }], fnDone);
}

// RAKTÁR END


// KÉSZLETSZINT START

static listKeszletszint(cikkcsoportId, cikkId, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'GET',
    url: Service.keszletUrl + 'keszletszint/list',
    args: { requestType: 'keszletszint-list' },
    params: {
      cikkcsoportId, cikkId
    }
  }], fnDone);
}

static listKeszletszintCikk(cikkcsoportIds, cikkIds, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'GET',
    url: Service.keszletUrl + 'keszletszint/list/cikk',
    args: { requestType: 'keszletszint-list-cikk' },
    params: {
      cikkcsoportIds, cikkIds
    }
  }], fnDone);
}

static addKeszletszint(keszletszintObject, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'POST',
    url: Service.keszletUrl + 'keszletszint',
    args: { requestType: 'keszletszint-post' },
    data: keszletszintObject
  }], fnDone);
}

static editKeszletszint(keszletszintObject, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'PUT',
    url: Service.keszletUrl + 'keszletszint',
    args: { requestType: 'keszletszint-put' },
    data: keszletszintObject,
  }], fnDone);
}

static deleteKeszletszint(id, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'DELETE',
    url: Service.keszletUrl + 'keszletszint',
    args: { requestType: 'keszletszint-delete' },
    params: { id },
  }], fnDone);
}

static deleteKeszletszintGroup(ids, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'DELETE',
    url: Service.keszletUrl + 'keszletszint/deletegroup',
    args: { requestType: 'keszletszint-deletegroup' },
    params: { ids },
  }], fnDone);
}

static listErtesites(fnDone) {
  Lib.MicroServices.requestService([{
    method: 'GET',
    url: Service.keszletUrl + 'ertesites/list',
    args: { requestType: 'ertesites-list' },
  }], fnDone);
}

static addErtesites(ertesitesObject, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'POST',
    url: Service.keszletUrl + 'ertesites',
    args: { requestType: 'ertesites-post' },
    data: ertesitesObject
  }], fnDone);
}

static editErtesites(ertesitesObject, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'PUT',
    url: Service.keszletUrl + 'ertesites',
    args: { requestType: 'ertesites-put' },
    data: ertesitesObject,
  }], fnDone);
}

static deleteErtesites(id, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'DELETE',
    url: Service.keszletUrl + 'ertesites',
    args: { requestType: 'ertesites-delete' },
    params: { id },
  }], fnDone);
}

// KÉSZLETSZINT END

// SZERVEZET START

static listSzemelyek(fnDone) {
  Lib.MicroServices.requestService([{
    method: 'GET',
    url: Service.szervezetUrl + 'szemely/getaktivszemelyek',
    args: { requestType: 'szemely-getaktivszemelyek' },
  }], fnDone);
}

// SZERVEZET END

}
